import DOMPurify from 'dompurify'
import SparkleIcon from 'src/components/Icons/SparkleIcon'

function boldfy(texto: string): string {
  return texto.replace(/\*(.*?)\*/g, '<strong>$1</strong>')
}

const SizeGuideRecommendation = ({
  recommendation,
  openSizeGuideModal,
}: {
  recommendation: string
  openSizeGuideModal: () => void
}) => {
  return (
    <button
      onClick={openSizeGuideModal}
      className="size-guide-recommendation-wrapper bg-neutral02 px-2 py-4 flex justify-between text-left gap-1 mt-4"
    >
      <div className="w-4 h-4">
        <SparkleIcon />
      </div>
      <span
        className="text-xs"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: DOMPurify?.sanitize
            ? DOMPurify.sanitize(boldfy(recommendation))
            : boldfy(recommendation),
        }}
      />
    </button>
  )
}

export default SizeGuideRecommendation
